import { BaseService } from "./BaseService";
import {
  CreateTenantUserDto,
  UserCreationResponse,
  UserFilterOptions,
  UserFilters,
} from "@/types/user";
import { UserProfile } from "@/types/user-profile";
import { tenantHeadersOptions } from "@/utils/hotelSubscriptionAccess";

export interface AdminUsersListResponse {
  items: UserProfile[];
  total: number;
  limit: number;
  offset: number;
}

class AdminUsersService extends BaseService {
  private readonly basePath = "/admin/users";

  getUsers(filters?: UserFilters): Promise<AdminUsersListResponse> {
    return this.get<AdminUsersListResponse>(this.basePath, filters, {
      skipSelectedHotelHeader: true,
    });
  }

  getUserFilterOptions(filters?: UserFilters): Promise<UserFilterOptions> {
    return this.get<UserFilterOptions>(
      `${this.basePath}/filter-options`,
      filters,
      {
        skipSelectedHotelHeader: true,
      },
    );
  }

  /**
   * Creates a user in `tenantId` (platform admins, e.g. Add user in the hotel
   * form of a tenant). The tenant also goes in `x-tenant-id`: the backend
   * resolves the tenant's region from it (DV-168).
   */
  createTenantUser(
    tenantId: string,
    userData: CreateTenantUserDto,
  ): Promise<UserCreationResponse> {
    return this.post<UserCreationResponse>(
      this.basePath,
      { tenantId, ...userData },
      { skipSelectedHotelHeader: true, ...tenantHeadersOptions(tenantId) },
    );
  }
}

export const adminUsersService = new AdminUsersService();
